
import React, { Fragment, useState, useEffect } from 'react';
import { Link, useHistory, useParams } from 'react-router-dom';
import { postData, fetchData, updateData, deleteData } from '../../../apiService';
import { useAuth } from '../../../AuthContext';
import { tokenIsExpired } from '../../../authUtils';
import Button from '@mui/material/Button';
import CircularProgress from '@mui/material/CircularProgress';
import CopyrightIcon from '@mui/icons-material/Copyright';
import Select from 'react-select'; // Import react-select

const AttendanceEdit = ({ match }) => {
    const [isLoading, setIsLoading] = useState(false);
    const history = useHistory();
    const { id } = useParams();
    const { isAuthenticated, companyId, userId, logout, token } = useAuth();

    useEffect(() => {
        if (isAuthenticated && tokenIsExpired(token)) {
            logout();
            return;
        }

    }, [isAuthenticated, companyId, token, logout]);


    const [successMessage, setSuccessMessage] = useState('');
    const [errorMessage, setErrorMessage] = useState('');



    const [formData, setFormData] = useState({});

    useEffect(() => {
        fetchData('AttendanceApi', `/EmployeeData/${id}`, token)
            .then((response) => {
                console.log('API response:', response);
                if (response.responseCode === '1111') {
                    setFormData(response.response_data);

                    setSelectedStatus({
                        value: response.response_data.StatusId,
                        label: response.response_data.statusName
                    });

                    setFormData((prevData) => ({
                        ...prevData,
                        UpdatedBy: userId,
                    }));

                }
            })
            .catch((error) => {
                console.error('Error fetching data:', error);
            });
    }, [id, userId, token]);



    const submitData = async () => {
        // Update CreatedBy field
        setFormData((prevData) => ({
            ...prevData,
            UpdatedBy: userId,
        }));


        const formatToFullTime = (time) => {
            if (!time) return null;
            return time.length === 5 ? `${time}:00` : time; // e.g., "14:30" → "14:30:00"
        };

        const dataToSend = {
            ...formData,
            InTime: formatToFullTime(formData.InTime),
            OutTime: formatToFullTime(formData.OutTime),
            Duration: formatToFullTime(formData.Duration),
        };


        // Update data
        try {
            const response = await updateData('AttendanceApi', id, dataToSend, token);
            console.log('Record updated successfully:', response);
            setSuccessMessage('Record updated successfully.');
            setTimeout(() => setSuccessMessage(''), 3000);
            history.push('/AttendanceIndex');
        } catch (error) {
            console.error('Error updating record:', error);
        }
    };


    const formatDateForInput = (dateString) => {
        const currentDate = new Date(dateString);;
        const year = currentDate.getFullYear();
        const month = String(currentDate.getMonth() + 1).padStart(2, '0');
        const day = String(currentDate.getDate()).padStart(2, '0');
        const formattedDate = `${year}-${month}-${day}`;

        return formattedDate;
    };

    const handleChange = (e) => {
        const { name, value } = e.target;

        setFormData(prev => {
            const updatedForm = { ...prev, [name]: value };

            // If both InTime and OutTime are available, calculate duration
            if (updatedForm.InTime && updatedForm.OutTime) {
                const duration = calculateDuration(updatedForm.InTime, updatedForm.OutTime);
                updatedForm.Duration = duration;
            }

            return updatedForm;
        });
    };

    const calculateDuration = (inTime, outTime) => {
        const [inH, inM] = inTime.split(':').map(Number);
        const [outH, outM] = outTime.split(':').map(Number);

        let inMinutes = inH * 60 + inM;
        let outMinutes = outH * 60 + outM;

        // Handle overnight shift
        if (outMinutes < inMinutes) {
            outMinutes += 24 * 60;
        }

        const durationMinutes = outMinutes - inMinutes;
        const hours = Math.floor(durationMinutes / 60);
        const minutes = durationMinutes % 60;

        // Format as "HH:mm"
        return `${String(hours).padStart(2, '0')}:${String(minutes).padStart(2, '0')}`;
    };



    const [statusOptions, setStatusOptions] = useState([]);
    const [selectedStatus, setSelectedStatus] = useState("true");

    useEffect(() => {
        fetchStatus();
    }, []);


    const fetchStatus = async () => {
        try {
            const response = await fetchData('AttendanceApi', `/Status/${companyId}`, token);
            if (response.responseCode === '1111') {

                const options = response.response_data.map(method => ({
                    value: method.Id,
                    label: method.Name
                }));
                setStatusOptions(options);
            }
        } catch (error) {
            console.error('Error fetching Status:', error);
        }
    };

    const handleStatusChange = (selectedOption) => {
        setSelectedStatus(selectedOption);
        setFormData((prevData) => ({
            ...prevData,
            StatusId: selectedOption.value,
        }));
    };



    return (
        <Fragment>
            <div className="w-full max-w-sm container mt-6 mx-auto" style={{ minWidth: '101%' }}>

                <div className='w-full mb-2 flex'>
                    <h6 className='block uppercase tracking-wide text-black productHead flex-grow linkcolor' style={{ fontFamily: 'Georgia, Cambria, "Times New Roman", Times, serif' }}>Attendance Edit</h6>

                    <Button

                        style={{
                            background: 'linear-gradient(to right,rgb(94, 179, 138),rgb(98, 150, 61))',
                            color: 'white',
                            textTransform: 'none',
                            boxShadow: '0 4px 6px rgba(0, 0, 0, 0.3)',
                            maxHeight: '30px',
                            marginLeft: '15px',

                        }}
                        onClick={submitData}
                        disabled={isLoading}
                    >
                        {isLoading ? <CircularProgress size={24} color="inherit" /> : <span>Update</span>}
                    </Button>

                    <Button

                        component={Link}
                        to="/AttendanceIndex"
                        className="linkcolor"
                        style={{
                            background: 'linear-gradient(to right,rgb(162, 31, 31),rgb(223, 91, 70))',
                            color: 'white',
                            textTransform: 'none',
                            boxShadow: '0 4px 6px rgba(0, 0, 0, 0.3)',
                            maxHeight: '30px',
                            marginLeft: '15px',

                        }}
                    >
                        Cancel
                    </Button>

                </div>

                {errorMessage && <p className="text-red-500">{errorMessage}</p>}
                {successMessage && <p className="text-green-500">{successMessage}</p>}

                <div className="watermark">
                    <CopyrightIcon /><b style={{ fontFamily: 'Script Bold Italic' }}>EFFTABS SOLUTIONS LLP</b>
                </div>


                <div className="w-full flex flex-wrap">
                    <div className="w-full" style={{ padding: '7px', borderRadius: '10px', marginTop: '-10px' }}>
                        <div className="w-full mb-3 flex" >

                            <div className="w-2/4 mr-2">
                                <label className="block uppercase tracking-wide text-black text-xs font-bold mb-2">
                                    Employee Name
                                </label>
                                <input
                                    className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline"
                                    value={formData.EmployeeName}
                                    onChange={handleChange}
                                    type="text"
                                    placeholder="EmployeeName"
                                    name='EmployeeName'
                                    onClick={(e) => e.target.select()}
                                    readOnly
                                />
                            </div>

                            <div className="w-1/5 mr-2">
                                <label className="block uppercase tracking-wide text-black text-xs font-bold mb-2">
                                    Employee Code
                                </label>
                                <input
                                    className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline"
                                    value={formData.EmployeeCode}
                                    onChange={handleChange}
                                    type="text"
                                    placeholder="Employee Code"
                                    name='EmployeeCode'
                                    onClick={(e) => e.target.select()}
                                    readOnly
                                />
                            </div>

                            <div className="w-1/5 mr-2">
                                <label className="block uppercase tracking-wide text-black text-xs font-bold mb-2">
                                    Department
                                </label>
                                <input
                                    className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline"
                                    value={formData.Department}
                                    onChange={handleChange}
                                    type="text"
                                    placeholder="Department"
                                    name='Department'
                                    onClick={(e) => e.target.select()}
                                    readOnly
                                />
                            </div>

                            <div className="w-1/5 mr-2">
                                <label className="block uppercase tracking-wide text-black text-xs font-bold mb-2">
                                    Designation
                                </label>
                                <input
                                    className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline"
                                    value={formData.Designation}
                                    onChange={handleChange}
                                    type="text"
                                    placeholder="Designation"
                                    name='Designation'
                                    onClick={(e) => e.target.select()}
                                    readOnly
                                />
                            </div>

                            <div className="w-1/5 mr-2">
                                <label className="block uppercase tracking-wide text-black text-xs font-bold mb-2" htmlFor="billDate">
                                    Date
                                </label>
                                <input
                                    className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline"
                                    value={formatDateForInput(formData.AttendanceDate)}
                                    onChange={handleChange}
                                    type="date"
                                    name='AttendanceDate'
                                    readOnly
                                    style={{ height: '35px' }}
                                    disabled
                                />
                            </div>


                        </div>

                        <div className="w-full mb-3 flex" >
                            <div className="w-1/5 mr-2">
                                <label className="block uppercase tracking-wide text-black text-xs font-bold mb-2" htmlFor="billDate">
                                    In Time
                                </label>
                                <input
                                    className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline"
                                    value={formData.InTime?.substring(0, 5)} // Show only "HH:mm"
                                    onChange={handleChange}
                                    type="time"
                                    name='InTime'
                                    style={{ height: '35px' }}
                                />
                            </div>

                            <div className="w-1/5 mr-2">
                                <label className="block uppercase tracking-wide text-black text-xs font-bold mb-2" htmlFor="billDate">
                                    Out Time
                                </label>
                                <input
                                    className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline"
                                    value={formData.OutTime?.substring(0, 5)} // Show only "HH:mm"
                                    onChange={handleChange}
                                    type="time"
                                    name='OutTime'
                                    style={{ height: '35px' }}
                                />
                            </div>

                            <div className="w-1/5 mr-2">
                                <label className="block uppercase tracking-wide text-black text-xs font-bold mb-2" htmlFor="billDate">
                                    Duration
                                </label>
                                <input
                                    className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline"
                                    value={formData.Duration?.substring(0, 5)} // e.g., "08:30"
                                    onChange={handleChange}
                                    name="Duration"
                                    style={{ height: '35px' }}
                                    step="60" // Optional: steps in seconds, this disables seconds input
                                    readOnly
                                />
                            </div>

                            <div className="w-2/5 mr-2">
                                <label className="block uppercase tracking-wide text-black text-xs font-bold mb-2">
                                    Location In
                                </label>
                                <input
                                    className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline"
                                    value={formData.LocationIn}
                                    onChange={handleChange}
                                    type="text"
                                    placeholder="LocationIn"
                                    name='LocationIn'
                                    onClick={(e) => e.target.select()}
                                />
                            </div>

                            <div className="w-2/5 mr-2">
                                <label className="block uppercase tracking-wide text-black text-xs font-bold mb-2">
                                    Location Out
                                </label>
                                <input
                                    className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline"
                                    value={formData.LocationOut}
                                    onChange={handleChange}
                                    type="text"
                                    placeholder="LocationOut"
                                    name='LocationOut'
                                    onClick={(e) => e.target.select()}
                                />
                            </div>

                            <div className="w-1/5 mr-2">
                                <label className="block uppercase tracking-wide text-black text-xs font-bold mb-2" >
                                    Status
                                </label>

                                <Select
                                    value={selectedStatus}
                                    onChange={handleStatusChange}
                                    options={statusOptions}
                                    placeholder="Status Option"
                                    isSearchable
                                />
                            </div>


                        </div>

                    </div>

                </div>


            </div >
        </Fragment >
    );
};


export default AttendanceEdit;